var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-8 is-offset-2 content"},[_c('div',{staticClass:"box"},[_c('h1',[_vm._v(_vm._s(_vm.getTitle))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.getDescription))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }